import "./css/index.css";
import React, { FC } from "react";
import { ODSCardImageHeadingProps } from "./ODSCardImage.types";
import { getCardImageHeadingTag } from "./ODSCardImage.utils";

const ODSCardImageHeading: FC<ODSCardImageHeadingProps> = ({
  children,
  level = 2,
  ...rest
}) => {
  const HeadingTag = getCardImageHeadingTag(level);
  return <HeadingTag {...rest}>{children}</HeadingTag>;
};

export default ODSCardImageHeading;
